import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Queue from "@/pages/Queue";
import Content from "@/pages/Content";
import Logs from "@/pages/Logs";
import Settings from "@/pages/Settings";
import LeadsAdmin from "@/pages/LeadsAdmin";
import DistributionAdmin from "@/pages/DistributionAdmin";
import LoginPage from "@/pages/LoginPage";

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <Routes>
          {/* v1.2.2: Public login route */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="admin/ops" element={<Dashboard />} />
            <Route path="queue" element={<Queue />} />
            <Route path="content" element={<Content />} />
            <Route path="logs" element={<Logs />} />
            <Route path="settings" element={<Settings />} />
            <Route path="admin/leads" element={<LeadsAdmin />} />
            <Route path="admin/distribution" element={<DistributionAdmin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
